import { PAGE_SIZE } from '@constants/common.constants';
import { MEMBER_HISTORICAL_DOCUMENTS_ACTION_TYPES } from '@constants/actionTypes/memberHistoricalDocumentsActionTypes';
import {
    HISTORICAL_DOCUMENTS_DEFAULT_SORT_COLUMN,
    HISTORICAL_DOCUMENTS_DEFAULT_SORT_ORDER,
    HISTORICAL_DOCUMENTS_INITIAL_PAGE_NUMBER,
    type IHistoricalDocumentsListState,
} from '@modules/historical-documents/constants';

export const INITIAL_STATE: IHistoricalDocumentsListState = {
    hasLoaded: false,
    documents: [],
    totalCount: 0,
    pageNumber: HISTORICAL_DOCUMENTS_INITIAL_PAGE_NUMBER,
    pageSize: PAGE_SIZE,
    totalPages: 0,
    sortColumn: HISTORICAL_DOCUMENTS_DEFAULT_SORT_COLUMN,
    sortOrder: HISTORICAL_DOCUMENTS_DEFAULT_SORT_ORDER,
    hasLoadError: false,
};

function memberHistoricalDocumentsReducer(
    state = INITIAL_STATE,
    action: { type?: string; payload?: IHistoricalDocumentsListState } = {},
) {
    switch (action.type) {
        case MEMBER_HISTORICAL_DOCUMENTS_ACTION_TYPES.SET_MEMBER_HISTORICAL_DOCUMENTS: {
            if (!action.payload) {
                return state;
            }

            return { ...state, ...action.payload };
        }
        case MEMBER_HISTORICAL_DOCUMENTS_ACTION_TYPES.RESET_MEMBER_HISTORICAL_DOCUMENTS:
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default memberHistoricalDocumentsReducer;
